module.exports = __webpack_public_path__ + "img/clock-white.ef945997.svg";